<div>
  <ng-container *ngIf="isMobile">
    <div (click)="goToLogin()" class="arrow-left">
      <img src="assets/image/arrow-left.svg" />
    </div>
  </ng-container>
  <ng-container *ngIf="!isMobile">
    <div class="desc">
      <div class="mt-5 text-center">
        <img
          *ngIf="personType == 'pj'"
          src="assets/image/merchants/{{ tenant }}/logo-login-blue.svg"
        />
        <img
          *ngIf="personType == 'pf'"
          src="assets/image/merchants/{{ tenant }}/logo-login-blue-pf.svg"
        />
      </div>
      <div class="text-login mt-3 text-center">
        <ng-container *ngIf="tenant === tenantService.XP_NAME">
          <h1>Plataforma OZ</h1>
        </ng-container>

        <ng-container *ngIf="tenant != tenantService.XP_NAME">
          <h1 *ngIf="personType == 'pj'">Plataforma de câmbio</h1>
          <h1 *ngIf="personType == 'pf'">Plataforma de câmbio</h1>
        </ng-container>

        <div class="mt-5 mb-5 text-center">
          <img src="assets/image/circles.svg" alt="Logo Oz Câmbio" />
        </div>
      </div>
    </div>
  </ng-container>

  <div class="container-login">
    <div class="text-login mt-5">
      <h4>Criação de nova senha</h4>
      <p class="mt-3">Informe uma nova senha para entrar na plataforma.</p>
    </div>
    <form [formGroup]="activeForm" class="mt-3">
      <div>
        <mat-form-field appearance="outline">
          <mat-label>Senha</mat-label>

          <input
            [type]="hide ? 'password' : 'text'"
            matInput
            formControlName="password"
          />

          <button
            class="eye-color"
            mat-icon-button
            matSuffix
            (click)="hide = !hide"
            [attr.aria-label]="'Hide password'"
            [attr.aria-pressed]="hide"
          >
            <img
              [src]="
                hide
                  ? 'assets/image/eye-icon-open.svg'
                  : 'assets/image/eye-icon-close.svg'
              "
            />
          </button>

          <mat-error
            class="mb-1"
            *ngIf="
              activeControl.password.touched &&
              activeControl.password.errors?.required
            "
          >
            Senha obrigatória
          </mat-error>
          <mat-error
            class="mb-1"
            *ngIf="
              activeControl.password.touched &&
              activeControl.password.errors?.minlength
            "
          >
            Digite uma senha de no mínimo oito caracteres
          </mat-error>
        </mat-form-field>
      </div>
      <div class="mt-3">
        <ng-container *ngIf="personType == 'pj'">
          <button
            class="btn btn-block mt-3"
            type="button"
            [ngClass]="{
              'btn-disabled': activeForm.invalid,
              'btn-dark-blue': !activeForm.invalid
            }"
            (click)="onSubmit($event)"
            [disabled]="activeForm.invalid"
          >
            Enviar
            <span
              class="spinner-border spinner-border-sm"
              *ngIf="loading"
            ></span>
          </button>
        </ng-container>

        <ng-container *ngIf="personType == 'pf'">
          <button
            class="btn btn-block mt-3"
            type="button"
            [ngClass]="{
              'btn-disabled': activeForm.invalid,
              'btn-dark-blue-pf': !activeForm.invalid
            }"
            (click)="onSubmit($event)"
            [disabled]="activeForm.invalid"
          >
            Enviar
            <span
              class="spinner-border spinner-border-sm"
              *ngIf="loading"
            ></span>
          </button>
        </ng-container>
      </div>

      <ng-container *ngIf="isMobile">
        <div class="text-center mt-5 lg-bottom">
          <img
            class="logo-oz"
            src="../../../../assets/image/merchants/{{
              merchant
            }}/oz-white-logo.svg"
            alt="logo"
          />
        </div>
      </ng-container>
    </form>
  </div>
</div>
